// extracted by mini-css-extract-plugin
export default {"rtl":"styles_rtl__BBRq+","main__layout":"styles_main__layout__rLlNB"};